// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"72":"a279da7b8666d104cefa","411":"4a7d2e3757750b70f9e0"}[chunkId] + ".js";
};